import React from 'react';
import { ReactComponent as PaymentIcon } from './icons/credit_card_24dp_4CAF50_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as TransactionsIcon } from './icons/receipt_long_24dp_42A5F5_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as ReferralIcon } from './icons/partner_exchange_24dp_AB47BC_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as SupportIcon } from './icons/forum_24dp_FF9100_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as AgreementIcon } from './icons/quick_reference_24dp_EC407A_FILL0_wght400_GRAD0_opsz24.svg';

const iconMap = {
  payment: { Icon: PaymentIcon, color: '#4caf50' }, // зелёный
  transactions: { Icon: TransactionsIcon, color: '#42a5f5' }, // синий
  referral: { Icon: ReferralIcon, color: '#ab47bc' }, // фиолетовый
  support: { Icon: SupportIcon, color: '#ff9100' }, // оранжевый
  agreement: { Icon: AgreementIcon, color: '#ec407a' }, // розовый
};

export function ProfileIcon({ type, size = 28, style = {} }) {
  const item = iconMap[type];
  if (!item) return null;
  const { Icon, color } = item;
  return <Icon width={size} height={size} style={{ color, ...style }} className="profile-list-icon" />;
} 